import {weChatrequest} from '@/utils/request'

// 查询角色列表
export function listRole(query) {
  return weChatrequest({
    url: '/api/v1/roles/page',
    method: 'get',
    params: query
  })
}

// 查询角色权限详细

export function getRole(roleId) {
  return weChatrequest({
    url: `/api/v1/roles/${roleId}/menuIds`,
    method: 'get'
  })
}
// 查询角色信息详细
export function getRoleForm(id) {
  return weChatrequest({
    url: `/api/v1/roles/${id}/form`,
    method: 'get'
  })
}
// 查询菜单权限详细
export function menusOptions() {
  return weChatrequest({
    url: '/api/v1/menus/options',
    method: 'get'
  })
}


// 新增角色
export function addRole(data) {
  return weChatrequest({
    url: '/api/v1/roles',
    method: 'post',
    data: data
  })
}

// 修改角色
export function updateRole(data) {
  return weChatrequest({
    url: `/api/v1/roles/${data.id}`,
    method: 'PUT',
    data: data
  })
}


// 角色数据权限
export function dataScope(data) {
  return weChatrequest({
    url: `/api/v1/roles/${data.roleId}/menus`,
    method: 'put',
    data: data.permKeywords
  })
}

// 删除角色
export function delRole(roleId) {
  return weChatrequest({
    url: `/api/v1/roles/${roleId}`,
    method: 'DELETE'
  })
}

// 查询角色下拉
export function getRoleOptions() {
  return weChatrequest({
    url: `/api/v1/roles/options`,
    method: 'get'
  })
}
// 查询部门权限下拉
export function getDeptOptions() {
  return weChatrequest({
    url: `/api/v1/users/dept/options`,
    method: 'get'
  })
}

// 查询用户列表
export function getUsers(query) {
  return weChatrequest({
    url: `/api/v1/users/page`,
    method: 'get',
    params: query
  })
}
// 新增用户
export function addUsers(data) {
  return weChatrequest({
    url: '/api/v1/users', 
    method: 'post',
    data: data
  })
}

// 编辑用户
export function updateUsers(data) {
  return weChatrequest({ 
    url: `/api/v1/users/${data.id}`,
    method: 'PUT',
    data: data
  })
}
// 用户详情
export function getUsersForm(id) {
  return weChatrequest({
    url: `/api/v1/users/${id}/form`,
    method: 'get'
  })
}

// 用户删除
export function delUsers(roleId) {
  return weChatrequest({
    url: `/api/v1/users/${roleId}`,
    method: 'DELETE'
  })
}
// 重置密码
export function updatePass(data) {
  return weChatrequest({
    url: `/api/v1/users/${data.id}/password`,
    method: 'post',
    data: {password: data.password}
  })
}
// 告警配置查询
export function warnListPage(data) {  
  return weChatrequest({
    url: `/api/v1/alarmDict/listPage`,
    method: 'post',
    data
  })
}
// 编辑告警配置
export function updateAlarmDict(data) {
  return weChatrequest({ 
    url: `/api/v1/alarmDict`,
    method: 'PUT',
    data: data
  })
}